/// <reference types="@angular/localize" />

import { importProvidersFrom } from '@angular/core';
import '@angular/localize/init';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, withViewTransitions } from '@angular/router';
import { initializeInternalAuth } from '@eforall/common';
import { provideMonacoEditor } from 'ngx-monaco-editor-v2';
import { environment } from './environments/environment';
import { monacoConfig } from './monaco-config';
import { BootstrapPage } from './pages/bootstrap/bootstrap.page';
import { routes } from './routes';


async function bootstrap() {

	(window as any).MonacoEnvironment = {
		getWorkerUrl: function (moduleId: string, label: string) {
			const base = '/assets/monaco/esm/vs';
			if (label === 'json') return `${base}/language/json/json.worker.js`;
			return `${base}/editor/editor.worker.js`;
		}
	};

	await initializeInternalAuth(environment);

	bootstrapApplication(
		BootstrapPage,
		{
			providers: [
				provideRouter(routes, withViewTransitions()),	// , withDebugTracing()),
				importProvidersFrom([BrowserAnimationsModule]),
				provideMonacoEditor(monacoConfig)
			]
		}
	).catch((err) => console.error(err));
}


bootstrap();